import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { ClientInvoiceDraft } from '../../../models/';
import { Observable } from 'rxjs';
import { ClientInvoice, CustomHttpResponse } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ClientInvoiceDraftService {
  apiService: ApiHttpService<ClientInvoiceDraft> = inject(ApiHttpService<ClientInvoiceDraft>);

  getForSupplierInvoiceSection(iri: string): Observable<ClientInvoiceDraft> {
    return this.apiService.get(`${iri}/client_invoice_draft`).pipe(map((result) => result.body));
  }

  delete(clientInvoiceDraftIri: string) {
    return this.apiService.delete(`${clientInvoiceDraftIri}`).pipe(map((result) => result));
  }

  create(clientInvoiceDraft: ClientInvoiceDraft): Observable<ClientInvoiceDraft> {
    return this.apiService
      .post('/client_invoice_drafts', clientInvoiceDraft)
      .pipe(map((result: CustomHttpResponse<ClientInvoiceDraft>) => result.body));
  }

  createInvoice(clientInvoiceDraftIri: string) {
    return this.apiService
      .post(`${clientInvoiceDraftIri}/create_client_invoice`, {} as ClientInvoiceDraft)
      .pipe(map((result: CustomHttpResponse<ClientInvoiceDraft>) => result.body as unknown as ClientInvoice));
  }
}
